import { useEffect, useState } from "react"
import { Box, Table, Thead, Tbody, Tr, Th, Td, TableContainer, Icon, useToast, Button,Text,
    SkeletonCircle, SkeletonText, Stack } from "@chakra-ui/react"
import { MdCheckBox, MdCheckBoxOutlineBlank,MdSaveAlt,MdCancel } from "react-icons/md"
import { getPopiseBySpecId } from "../../util/apiMRgg"
export const PopisGovedaSelect = ({ size = 'xs', specifikacije = [0],selectedRggId=[],onClose,onSelect }) => {
    const [data, setData] = useState([])
    const [dataisloading, setDataIsLoading] = useState(true);
    const [errmsg, setErrMsg] = useState("");

    const toast = useToast();
    useEffect(() => {
        const getData = async () => {
            try {
                const _sp=[...specifikacije];
                if (_sp.findIndex((item)=>item===0)===-1) {
                    _sp.push(0)
                }
                const res = await getPopiseBySpecId(_sp);
                
                if (res.status === 200) {
                    res.res.forEach((item) => {
                        if (selectedRggId.includes(item.rgg_id)) {
                            item.selected=true;
                        } else {
                            item.selected=false;
                        }
                        /*if (item.specifikacija_id !== 0) {
                            item.selected = true;
                        } else {
                            item.selected = false;
                        }*/
                    })
                    setData(res.res);
                } else {
                    setErrMsg(res.message);
                }
            } catch (error) {
                setErrMsg(error.message);
            } finally {
                setDataIsLoading(false)
            }
        }

        getData();
    }, [])


    const showErr = () => {
        if (errmsg !== "") {
            if (errmsg !== "") {
                toast({
                    title: "RGG",
                    status: "error",
                    description: errmsg,
                    isClosable: true,
                    duration: 2500,
                    position: "top-right",
                });
            }
        }
    }
    const getSkeleton = () => {
        if (dataisloading) {
            return (
                <Box display={'flex'} flexDir={'column'} flex={1}>
                    <SkeletonCircle size='10' />
                    <SkeletonText mt='4' noOfLines={10} spacing='4' skeletonHeight='4' />
                </Box>
            )
        }
    }
    const selectPopise=()=>{
        const _res=[];
        const filtered=data.filter((item)=>item.selected===true);
        for (let index = 0; index < filtered.length; index++) {
            _res.push(filtered[index].rgg_id);
        }
        onSelect(_res);
    }
    const showSelected=(selected)=>{
        if (selected) {
          return <Icon as={MdCheckBox} boxSize={5}/>
        } else {
          return <Icon as={MdCheckBoxOutlineBlank} boxSize={5}/>
        }
    }
    

    

    const setSelected=(_rggid)=>{
        const _newdata=[...data];
        const _idx=_newdata.findIndex((item)=>item.rgg_id===_rggid);
        if (_idx!==-1) {
            _newdata[_idx].selected=!_newdata[_idx].selected
            setData(_newdata);
            

        }
    }

    const buildScreen = () => {
        if (!dataisloading) {
            return (
                <Box display={'flex'} flexDir={'column'} flex={1}>
                <Box display={'flex'} flexDir={'row'} h={'1.5rem'} bg={'grunt2.700'} justifyContent={'center'} alignItems={'center'}
                borderTopLeftRadius={3} borderTopRightRadius={3}>
                    <Text color={'white'} fontSize={'sm'} fontWeight={'semibold'}>Popisi goveda</Text>
                </Box>
                <TableContainer >
                    <Table variant={'unstyled'} size={size}>
                        <Thead _hover={{ cursor: 'pointer' }} fontSize={size}>
                            <Tr>
                                <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Šifra</Th>
                                <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Datum</Th>
                                <Th w={'25%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Operater</Th>
                                <Th w={'40'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Lokacija</Th>
                                <Th w={'5%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Br. gov.</Th>
                                <Th w={'5%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Odaberi</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {data.map((item, i) => {
                                return (
                                    <Tr color={'grunt2'} key={data.rgg_id} bg={'white'} fontWeight={'normal'}
                                        _hover={{ bg: 'gray.100', cursor: 'pointer' }} h='2rem' onClick={()=>setSelected(item.rgg_id)}>
                                         <Td fontSize={size} textAlign={'center'}>
                                            {item.rgg_id}.
                                        </Td>
                                        <Td fontSize={size} textAlign={'center'}>
                                            {new Date(item.datum.toString().split('T')[0]).toLocaleDateString('hr-HR')}
                                        </Td>
                                        <Td fontSize={size} textAlign={'center'}>
                                            {item.operater}.
                                        </Td>
                                        <Td fontSize={size} textAlign={'center'} fontWeight={'normal'}>
                                            {item.lokacija}/{item.toviliste}/{item.odjeljak}
                                        </Td>
                                        <Td fontSize={size} textAlign={'center'}>
                                            {item.br_goveda}
                                        </Td>
                                        <Td fontSize={size} textAlign={'center'}>
                                            {showSelected(item.selected)}
                                        </Td>

                                    </Tr>
                                )
                            })}
                        </Tbody>
                    </Table>
                </TableContainer>
                </Box>
            )
        }
    }
    const getControls=()=>{
        return (
            <Box display={'flex'} flexDir={'row'} h={'2rem'} mt={'1.5rem'}>
                <Stack direction={'row'} spacing={'2rem'} flex={1}>
                    <Button rightIcon={<MdSaveAlt/>} size={'xs'} colorScheme={'grunt2'} variant={'outline'} onClick={selectPopise}>Prihvati</Button>
                    <Button rightIcon={<MdCancel/>} size={size} colorScheme={'grunt2'} variant={'outline'} onClick={onClose}>Odustani</Button>
                </Stack>
            </Box>
        )
    }
    return (
        <Box display={'flex'} flexDir={'column'} flex={1}>
            {showErr()}
            {getSkeleton()}
            {buildScreen()}
            {getControls()}
        </Box>
    )

}